<script setup>

</script>

<template>
  <svg id="Icons" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 45">
    <g id="revolution_immobilienwirtschaft_pfad">
      <path d="M41.94,44.79h-3v-10.17h-12.13l-1.84,1.85H1.67V3.97l1.8-1.8h16.56l1.85-1.85h20.06v44.46ZM4.67,33.47h19.05l1.84-1.85h13.37V3.33h-15.82l-1.85,1.85-16.6.04v28.25Z" fill="currentcolor"/>
      <polygon points="20.15 30.01 14.91 30.01 8.5 23.59 8.5 13.13 14.91 6.71 20.15 6.71 20.15 9.71 16.15 9.71 11.5 14.37 11.5 22.35 16.15 27.01 20.15 27.01 20.15 30.01" fill="currentcolor"/>
      <path d="M22.91,30.01v-3c3.49,0,8.65-2.75,8.65-8.65s-5.16-8.65-8.65-8.65v-3c5.6,0,11.65,4.45,11.65,11.65s-6.05,11.65-11.65,11.65Z" fill="currentcolor"/>
      <rect x="16.46" y="14.09" width="10.15" height="3" fill="currentcolor"/>
      <rect x="16.46" y="19.63" width="10.15" height="3" fill="currentcolor"/>
    </g>
  </svg>
</template>

<style scoped lang="scss">

</style>